<h2 mat-dialog-title>Plan territories</h2>

<mat-dialog-content class="tp-body">
  <p class="tp-lede">
    Every lead with an address is grouped into balanced territories, around the
    ones you drew yourself.
  </p>

  <!-- HOW MANY -->
  <section class="tp-q">
    <h3 class="tp-q-title">How many territories</h3>
    <label class="tp-choice">
      <input type="radio" name="tp-count" [checked]="followRoster"
             (change)="followRoster = true" />
      <span>
        One for each rep
        <em class="tp-note" *ngIf="facts.reps > 0">
          &mdash; {{ facts.reps }} today, and it follows the roster if that
          changes before the plan runs
        </em>
        <em class="tp-note" *ngIf="facts.reps === 0">
          &mdash; nobody is assignable yet, so this cuts 6
        </em>
      </span>
    </label>
    <label class="tp-choice">
      <input type="radio" name="tp-count" [checked]="!followRoster"
             (change)="followRoster = false" />
      <span class="tp-inline">
        Exactly
        <input type="number" class="br-form-control br-form-control--sm tp-num"
               [(ngModel)]="count" [disabled]="followRoster"
               min="1" [max]="120" aria-label="Number of territories" />
      </span>
    </label>
    <p class="tp-warn" *ngIf="countClamped">
      The planner cuts between 1 and 60. This will run as
      <b>{{ effectiveCount }}</b>.
    </p>
  </section>

  <!-- WHAT MAKES THEM EQUAL - AND THEREFORE WHAT DOES NOT.
       Each answer said only what it evens out, which reads as two ways of
       saying "fair" and leaves nothing to choose between. You cannot have
       both: making the money even makes the workload uneven, and the other
       way round. Saying which is given up is the whole of the decision. -->
  <section class="tp-q">
    <h3 class="tp-q-title">Make the territories equal in</h3>
    <label class="tp-choice">
      <input type="radio" name="tp-balance" [checked]="balanceBy === 'value'"
             (change)="balanceBy = 'value'" />
      <span>
        Expected revenue
        <em class="tp-note">
          &mdash; a $50k lead counts for ten $5k ones. Each rep
          gets a similar amount of money to chase, so the rep with the big
          accounts covers fewer leads.
        </em>
      </span>
    </label>
    <label class="tp-choice">
      <input type="radio" name="tp-balance" [checked]="balanceBy === 'leads'"
             (change)="balanceBy = 'leads'" />
      <span>
        Number of leads
        <em class="tp-note">
          &mdash; every lead counts once, whatever it is worth. Each rep gets
          a similar number of doors to knock on, so one territory may be worth
          far more than another.
        </em>
      </span>
    </label>
  </section>

  <!-- WHAT IT WILL DO TO WHAT IS ALREADY THERE. The part nobody can undo, and
       the part that was written down nowhere before this dialog existed. -->
  <div class="tp-effect" data-test="plan-effect">
    <br-icon>info</br-icon>
    <span>
      <ng-container *ngIf="facts.planned > 0">
        Replaces the <b>{{ facts.planned }}</b>
        {{ facts.planned === 1 ? 'territory' : 'territories' }} the last plan
        drew.
      </ng-container>
      <ng-container *ngIf="facts.planned === 0">
        Nothing here was drawn by a plan, so nothing is replaced.
      </ng-container>
      <ng-container *ngIf="facts.manual > 0">
        The <b>{{ facts.manual }}</b> you drew
        {{ facts.manual === 1 ? 'is' : 'are' }} left alone and planned around.
      </ng-container>
    </span>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button type="button" class="br-btn br-btn--ghost" (click)="cancel()">
    Cancel
  </button>
  <button type="button" class="br-btn br-btn--primary" (click)="run()"
          data-test="plan-run">
    Plan {{ effectiveCount }}
    {{ effectiveCount === 1 ? 'territory' : 'territories' }}
  </button>
</mat-dialog-actions>
